<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="confirmMessage"></p>
</div>
<div *ngIf="isAdminCustomInput">
  <mat-form-field>
    <input matInput [(ngModel)]="inputText" placeholder="Інформація про бронювання">
  </mat-form-field>
</div>
<div *ngIf="allowMarkAsYellow">
  <button mat-button (click)="markAsYellow()">{{yellowCardText}}</button>
</div>
<div mat-dialog-actions class="action-btns">
  <button mat-button (click)="dialogRef.close()">Скасувати</button>
  <button mat-button cdkFocusInitial (click)="confirm()">{{confirmActionText}}</button>
</div>
